import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { getGenerationsLocked } from '../../../core/ui';
import { getChart, chartActions } from '../../../core/chart';
import { getSelectedCell, cellsActions } from '../../../core/cells';
import { getSelectedGeneration, generationsActions } from '../../../core/generations';


import { _Slider, _Label, _Field, _Heading, _Paragraph } from '../styled-sidebar';
import ColorPicker from '../../common/color-picker';
import StyledColorBlock from '../../common/styled-color-block';
import { StyledScrollable, StyledMargin } from '../../common/styled-base';
import theme from '../../../styles/theme';

import { convertToHumanReadable, convertFromHumanReadable } from '../../../core/utils'

import Slider from 'material-ui/Slider';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';

class SimpleMenu extends React.Component {

  render() {
    const { 
      cell, 
      generation,
      chart,
      generationsLocked,
      setName, 
      setBirth, 
      setDeath,
      setFontSize,
      setThickness,
      setCellType,
      setGenerations,
     } = this.props;

    return (
      <StyledScrollable padding='15px'>    
        {!generationsLocked && 
          <div>
            <_Field>
              <_Heading>Chart Settings</_Heading>    
            </_Field>

            <_Field>
              <_Label>Generations: {chart.generations}</_Label>
              <_Slider>
                <Slider 
                  disableFocusRipple={true}
                  className="slider-ui"
                  min={4} 
                  max={9} 
                  step={1} 
                  value={chart.generations} 
                  onChange={(e, value) => setGenerations(value)} />
              </_Slider>
            </_Field>
          </div>
        }
        
        <_Field className="mt3">
          <_Heading>Individual Settings</_Heading>
          <_Paragraph className="mt1">Click on any name in the chart to edit an individual.</_Paragraph>
        </_Field>

        <_Field>
          <_Label>Name</_Label>
          <TextField 
            className="kt-textarea"
            id="name"
            multiLine={true}
            rows={2}
            value={convertToHumanReadable(generation.cellType, cell.name || '')} 
            underlineFocusStyle={{borderColor: theme.primary}}
            onChange={(e, value) => 
              setName(cell.ascendancy, convertFromHumanReadable(generation.cellType, value))
            } 
            />
        </_Field>

        <_Field>
          <_Label>Birth</_Label>
          <TextField           
            id="birth" 
            className="kt-textfield"
            value={cell.birth || ''} 
            inputStyle={{color: 'rgba(255,255,255,0.8'}}
            underlineFocusStyle={{borderColor: theme.primary}}
            onChange={(e, value) => setBirth(cell.ascendancy, value)} 
            />
        </_Field>

        <_Field>
          <_Label>Death</_Label>
          <TextField 
            id="death" 
            className="kt-textfield"
            value={cell.death || ''} 
            inputStyle={{color: 'rgba(255,255,255,0.8'}}
            underlineFocusStyle={{borderColor: theme.primary}}
            onChange={(e, value) => setDeath(cell.ascendancy, value)} 
            />
        </_Field>

        <_Field className="mt3">
          <_Heading>Generation Settings</_Heading>
        </_Field>

        <_Field>
          <_Label>Generation Font Size: {generation.fontSize}</_Label>
          <_Slider>
            <Slider 
              disableFocusRipple={true}
              className="slider-ui"
              min={0} 
              max={Math.max(80, generation.fontSize)} 
              step={1} 
              value={generation.fontSize}
              onChange={(e, value) => setFontSize(generation.index, value)} />
          </_Slider>
        </_Field>

        <_Field>
          <_Label>Generation Width: {generation.thickness}</_Label>
          <_Slider>
            <Slider
              disableFocusRipple={true}
              className="slider-ui" 
              min={Math.min(80, generation.thickness)} 
              max={200} 
              step={1} 
              value={generation.thickness} 
              onChange={(e, value) => setThickness(generation.index, value)} />
          </_Slider>
        </_Field>


        
      </StyledScrollable>
    )
  }
}

const mapStateToProps = createSelector(
  getSelectedCell,
  getSelectedGeneration,
  getChart,
  getGenerationsLocked,
  (cell, generation, chart, generationsLocked) => ({
    cell,
    generation,
    chart,
    generationsLocked,
  })  
)

const mapDispatchToProps = Object.assign({}, cellsActions, generationsActions, chartActions)
export default connect(mapStateToProps, mapDispatchToProps)(SimpleMenu);


// WEBPACK FOOTER //
// ./src/components/menu/simple-menu/index.js